const CONSTANTS = {
  PAGE_VIEW_3: 'pageview3',
  QUIZIZZ_EXP_NAME_KEY: 'QUIZIZZ_EXP_NAME',
  QUIZIZZ_EXP_SLOT_KEY: 'QUIZIZZ_EXP_SLOT',
  PAGEVIEW3: 'pageview3',
} as const;

export default CONSTANTS;
